import { render } from "./Sv057.vue?vue&type=template&id=70a9ee90&scoped=true"
import script from "./Sv057.vue?vue&type=script&lang=js"
export * from "./Sv057.vue?vue&type=script&lang=js"

import "./Sv057.vue?vue&type=style&index=0&id=70a9ee90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a9ee90"]])

export default __exports__